import { useSelector } from 'react-redux'
import { Button } from '@calendly/ui/components/button'
import { IconLink } from '@calendly/ui/components/glyphs/IconLink'
import { IconCheck } from '@calendly/ui/components/glyphs/IconCheck'
import { UiIcon } from '@calendly/ui/components/ui-icon'
import { useClipboard } from '@calendly/clipboard'
import styled from 'astroturf/react'

import { useI18n } from 'locales'
import { currentUserLocaleSelector, currentUserSelector } from 'selectors/user'
import { bookingLinkService } from 'services/analytics/booking_link_service'
import { customDomainSelector } from 'selectors/custom_domain'
import { useProfile } from 'components/use_profile'
import Segment from 'services/analytics/segment'
import { buildAnalyticsProperties } from 'utils/build_analytics_properties'

import { eventService } from '../../../services/analytics/event_service'
import _ButtonContainer from "copy_link_button-ButtonContainer.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/publisher_toolbar/booking_page_header_feature/copy_link_button.js?styleId=ButtonContainer";


const ButtonContainer = /*#__PURE__*/styled(Button, null, {
  displayName: "ButtonContainer",
  styles: _ButtonContainer
})

export const CopyLinkButton = ({ eventType }) => {
  const { i18n } = useI18n()
  const urlToCopy = window.location.origin + window.location.pathname
  const [Wrapper, ref, isCopied] = useClipboard(urlToCopy)
  const locale = useSelector(currentUserLocaleSelector)
  const currentUser = useSelector(currentUserSelector)
  const profile = useProfile()
  const copiedLabel = i18n.t('publisher.diagnostics.publisher_toolbar.copy_link_button.copied', { locale })
  const buttonText = isCopied ? copiedLabel : i18n.t('publisher.diagnostics.publisher_toolbar.copy_link_button.copy', { locale })

  const { isCustomDomain, linkDomain } = bookingLinkService.linkDomainData(urlToCopy, useSelector(customDomainSelector).default_domain)

  const sendBookingPageShared = () => {
    const baseProperties = {
      location_type: eventType.location_configurations[0]?.kind || null,
      event_type_name: eventType.name,
      share_object: 'event_type',
      share_object_id: 'NULL',
      share_method: 'copy_link',
      share_location: 'booking_page',
      is_single_use: false,
      is_customized_at_share: false,
      custom_domain: isCustomDomain,
      domain: linkDomain,
      ...(eventType.is_ai_notetaker_enabled != null && {
        is_ai_notetaker_enabled: eventType.is_ai_notetaker_enabled
      })
    }

    const analyticsProperties = buildAnalyticsProperties({
      entities: ['global', 'org', 'user'],
      eventType,
      currentUser,
      profile,
      additionalProperties: baseProperties
    })

    // Existing Analytics v2 (cloud mode)
    eventService.dispatch({
      name: 'Booking Page Shared',
      version: 2,
      dependencies: { user_id: profile.id },
      entities: ['user', 'organization'],
      properties: baseProperties
    })

    // Segment v1 (device-mode) for Braze
    Segment.track('Booking Page Shared', analyticsProperties, { version: 2 })
  }

  const trackCopyLink = () => {
    sendBookingPageShared()
  }

  return (
    <Wrapper>
      <ButtonContainer
        decoration="secondary-outline"
        ref={ref}
        onClick={trackCopyLink}
        role="button"
        aria-label={buttonText}
        aria-pressed={isCopied.toString()}
      >
        {isCopied ? <UiIcon icon={IconCheck} size="small" /> : <UiIcon icon={IconLink} size="small" />}
        {buttonText}
      </ButtonContainer>
    </Wrapper>
  )
}
